<template>

    

    <div style="padding:20px;">


        <v-card class="" elevation="" max-width="" style="margin-top:20px;" >
            <v-card-text>

                <div style="">
                    <h1 >Termos para Download</h1>
                </div>
                <div style="margin-top:20px;margin-left:30px;">
                     <p style="margin-bottom:20px!important;"><b>Termo de Serviço do Hotel Padrão</b></p>
                    <a target="_blank" href="../PDF/Termo-De-Responsabilidade-Padrao.pdf">Termo de Serviço</a>
                </div>
                <div style="margin-top:20px;margin-left:30px;">
                     <p style="margin-bottom:20px!important;"><b>Termo LGPD Padrão</b></p>
                    <a target="_blank" href="../PDF/Termo-LGPD-Padrao.pdf">Termo LGPD</a>
                </div>





            </v-card-text>
               
        </v-card>


    </div>

    
</template>

<script>

export default {
    name:'Robos',
    components: {
    },
    data(){
        return{
            
        }
    },
    watch: {
        
    },
    methods:{
            
    },

    
    async mounted(){

    }
    
}
</script>

<style>
    .linhaFormulario{
        display: flex;
        flex-direction: row;
        /* background-color:red; */
        padding-left: 10%;
        padding-right: 10%;
    }

    .celularCampoForm{
        width:25%;
        padding:10px;
        /* background-color: green; */
    }

    .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        color: rgba(0, 0, 0);
    }

</style>